import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Button } from "@mui/material"; // Using Material-UI
import AuditsController from "../Controller/audits_controller.ts";


const MobileAuditExcel = () => {
  const [data, setData] = useState([
    // { id: 1, name: "John Doe", actions: "Edit Member User Info", action_datetime: "2024-02-24" },
    // { id: 2, name: "Jane Smith", actions: "Edit Membership Application", action_datetime: "2024-02-23" },
    // { id: 3, name: "Alice Johnson", actions: "Edit Broadcast", action_datetime: "2024-02-22" },
  ]);

  useEffect(() => {
    AuditsController.getMobileAudits()
      .then((auditData) => {
        console.log("Audit Data:", auditData);
        setData(auditData);
      })
      .catch((error) => console.error("Error fetching audit data:", error));
  }, []);
  

  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data available!");
      return;
    }
  
    const headers = ["No.", "Full Name", "Audit Actions", "Action DateTime"];
  
    const formattedData = data.map((row, index) => [
      index + 1,
      row.name,
      row.action_label,
      row.datetime_created,
    ]);
  
    const worksheetData = [headers, ...formattedData];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  
    // ✅ Enable filter on the header row
    worksheet["!autofilter"] = {
      ref: `A1:D1`,
    };
  
    // ✅ Auto-resize columns
    worksheet["!cols"] = headers.map((header, i) => {
      const maxLength = worksheetData.reduce((max, row) => {
        const cell = row[i];
        const len = cell ? cell.toString().length : 0;
        return Math.max(max, len);
      }, header.length);
      return { wch: maxLength + 2 }; // +2 for padding
    });
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Audit Data");
  
    XLSX.writeFile(workbook, "MobileAuditReport.xlsx");
  };
  
  

  return (
    <Button variant="contained" color="success" onClick={exportToExcel}>
      Export Excel
    </Button>
  );
};

export default MobileAuditExcel;
